import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";
import translationFR from "../locales/fr.json";
import translationEN from "../locales/en.json";
import translationES from "../locales/es.json";
import translationCR from "../locales/es-cr.json";

i18n.use(reactI18nextModule).init({
  resources: {
    en: {
      translations: translationEN,
    },
    "en-ca": {
      translations: translationEN,
    },
    "es-CR": {
      translations: translationCR,
    },
    es: {
      translations: translationES,
    },
    fr: {
      translations: translationFR,
    },
  },
  fallbackLng: "en",
  debug: true,
  returnEmptyString: false,
  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false,

  interpolation: {
    escapeValue: false,
    formatSeparator: ",",
    format: function (value, format, lng) {
      if (format === "number" && typeof value === "number") {
        // Check if the number is not a whole number
        if (!Number.isInteger(value)) {
          return value.toFixed(2);
        }
      }
      return value;
    },
  },

  react: {
    wait: true,
  },
});

export const getUrlLocale = () => {
  let langPrefix = location.pathname.split("/")[1];
  return langPrefix !== 'en' && i18n.languages[0].toLowerCase() === langPrefix ? `/${langPrefix}` : "";
}

export default i18n;
